export const contact = {
  name: 'Mia Seo',
  title: 'Product Designer & Illustrator',
  email: 'hello@miaseo.work',
  availability: 'Available for freelance from Q1 2025 — limited capacity',
  location: 'Seoul, Korea — open to remote collaboration worldwide',
  intro:
    'I design digital products that put clarity ahead of complexity, and create visual assets that make brands more memorable. I am drawn to problems where information architecture, visual design, and user behavior intersect.',
  links: [
    { label: 'LinkedIn', href: '#' },
    { label: 'Behance', href: '#' },
    { label: 'Dribbble', href: '#' },
    { label: 'Are.na', href: '#' },
  ],
  services: [
    'Product design — UX, UI, and systems',
    'Illustration — brand, editorial, and digital',
    'Visual direction — campaigns and content',
  ],
};
